import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getOfferHistory, setPage, setRoomsFilter } from '../../../../store/offerHistory/actions';
import { selectActiveRoomsFilter } from '../../../../store/offerHistory/selectors';
import { THandleRoomsFiltersClick } from '../../components/types';
import { STATUS_ALL } from '../../../../store/offerHistory';
import { selectOfferId } from '../../../../selectors/offerData/offer';
import { trackOfferFilterSelect } from '../analytics';

/**
 * Хендлер клика по фильтру комнатности
 * */
export const useHandleRoomsFiltersClick = (): THandleRoomsFiltersClick => {
  const dispatch = useDispatch();
  const roomsFiltersActiveIDs = useSelector(selectActiveRoomsFilter);
  const offerId = useSelector(selectOfferId);

  return React.useCallback(
    id => {
      if ((roomsFiltersActiveIDs && id === roomsFiltersActiveIDs[0]) || id === STATUS_ALL) {
        dispatch(setRoomsFilter(null));
      } else {
        dispatch(setRoomsFilter([id]));
      }

      dispatch(setPage(1));
      dispatch(getOfferHistory(false));
      trackOfferFilterSelect(offerId, id);
    },
    [dispatch, roomsFiltersActiveIDs, offerId],
  );
};
